module.exports = __webpack_public_path__ + "e9d02470cfb6c4a9ba2cf132a826ac4e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_2-420.webp.png
// module id = 580
// module chunks = 0